<template>
  <div class="input-tool">
    <!-- PC -->
    <div v-if="type === 1" class="input-tool__pc flex flex-item-center">
      <el-tooltip content="表情" placement="top" effect="light">
        <i class="input-tool__tool-item iconfont icon-biaoqing" @click="handleEmoji"></i>
      </el-tooltip>
      <el-tooltip placement="top" content="支持发送图片和视频" effect="light">
        <i class="input-tool__tool-item iconfont icon-tupian" @click="handleUpload(3)"></i>
      </el-tooltip>
      <el-tooltip placement="top" content="支持发送word、excel、pdf、ppt、pptx、txt" effect="light">
        <i class="input-tool__tool-item iconfont icon-wenjian" @click="handleUpload(4)"></i>
      </el-tooltip>
      <img
        class="input-tool__tool-item"
        v-for="(item, index) in shortCuts"
        :key="index"
        :src="item.icon"
        :alt="item.name"
        @click="handleCustomClick(item)"
      />
    </div>
    <!-- 移动端 -->
    <div v-else class="input-tool__h5 flex flex-wrap">
      <div class="input-tool__h5-item" @click="handleUpload(3)">
        <i class="img iconfont icon-zhaopian"></i>
        <div class="text">图片</div>
      </div>
      <div class="input-tool__h5-item" @click="handleUpload(4)">
        <i class="img iconfont icon-wenjianjia-"></i>
        <div class="text">文件</div>
      </div>
      <div v-if="isShowComment" class="input-tool__h5-item" @click="handleComment">
        <i class="img iconfont icon-pingjiajilu"></i>
        <div class="text">评价</div>
      </div>
      <!-- 结束会话 -->
      <div v-if="closeSessionEnable" class="input-tool__h5-item" @click="handleQuit">
        <i class="img iconfont icon-tuichu"></i>
        <div class="text">退出</div>
      </div>
      <div class="input-tool__h5-item" v-for="(item, index) in shortCuts" :key="index" @click="handleCustomClick(item)">
        <img class="img" :src="item.icon" />
        <div class="text">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>
<script setup name="InputTool">
import { defineEmits, defineProps } from 'vue'
const props = defineProps({
  shortCuts: { type: Array, default: () => [] },
  isShowComment: { type: Boolean },
  closeSessionEnable: { type: Boolean, default: true }, //是否可以结束会话
  type: { type: Number, default: 1 } //1PC端输入 2移动端输入
})
const emit = defineEmits(['emoji', 'upload', 'custom', 'comment', 'quit'])
// 表情包点击
const handleEmoji = () => {
  emit('emoji')
}
// 上传图片
const handleUpload = (type) => {
  emit('upload', type)
}
// 自定义按钮点击
const handleCustomClick = (data) => {
  emit('custom', data)
}
// 评价
const handleComment = () => {
  emit('comment')
}
// 结束会话
const handleQuit = () => {
  emit('quit')
}
</script>
<style lang="less" scoped>
.input-tool {
  &__pc {
    height: 40px;
    border-bottom: 1px solid #eee;
    padding: 0 10px;
    box-sizing: border-box;
  }
  &__tool-item {
    cursor: pointer;
    width: 20px;
    height: 20px;
    font-size: 20px;
    color: #64656d;
    & + & {
      margin-left: 12px;
    }
  }
  &__h5 {
    box-sizing: border-box;
    height: 200px;
    padding: 10px;
  }
  &__h5-item {
    width: 25%;
    height: 84px;
    text-align: center;
    font-size: 13px;
    cursor: pointer;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .img {
      background-color: #fff;
      border-radius: 10px;
      padding: 15px;
      box-sizing: border-box;
      width: 54px;
      height: 54px;
      object-fit: contain;
      display: block;
      margin: 0 auto;
      font-size: 28px;
      color: #64656d;
    }

    .text {
      font-size: 14px;
      color: #5a5b64;
      margin-top: 3px;
    }
    .iconfont {
      font-size: 26px;
    }
  }
}
</style>
